var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.508343C11.1746 0.182973 10.649 0.182973 10.3237 0.508343L6.24403 4.57964L2.16439 0.5C1.83902 0.17463 1.31343 0.17463 0.988055 0.5C0.662686 0.82537 0.662686 1.35097 0.988055 1.67634L5.06769 5.75597L0.988055 9.83561C0.662686 10.161 0.662686 10.6866 0.988055 11.0119C1.31343 11.3373 1.83902 11.3373 2.16439 11.0119L6.24403 6.93231L10.3237 11.0119C10.649 11.3373 11.1746 11.3373 11.5 11.0119C11.8254 10.6866 11.8254 10.161 11.5 9.83561L7.42036 5.75597L11.5 1.67634C11.817 1.35931 11.817 0.82537 11.5 0.508343Z",
    fill: "#383842"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.62944e4d1e76190c560665638bed3d2b.svg";
export { ForwardRef as ReactComponent };